
import { defineComponent, PropType } from 'vue'

import type { RouteNavigationParams } from '~/utils/router'

export default defineComponent({
  name: 'UICard',
  props: {
    to: {
      type: [String, Object] as PropType<string | RouteNavigationParams> | null,
      default: null
    }
  },
  computed: {
    componentIs() {
      if (this.to) {
        if (typeof this.to === 'string' && this.to.startsWith('http')) {
          return 'a'
        } else {
          return 'router-link'
        }
      } else {
        return 'div'
      }
    },
    dynamicAttrs() {
      if (this.componentIs === 'a') {
        return { target: '_blank', rel: 'noopener noreferrer', href: this.to }
      }
      if (this.componentIs === 'router-link') {
        return { to: this.to }
      }
      return {}
    }
  }
})
